export default __webpack_public_path__ + "static/media/avatar3.90ce3b85.png";